import { format } from '@appd/uik';
import { ValueType } from '../models';

/**
 * Returns the formatted value based on default guidelines
 * @param value value to be formatted
 * @param type type of value
 * @returns formatted value as a string
 */
export const applyDefaultFormatter = (value: any, type: ValueType): string => {
  switch (type) {
    case ValueType.NUMBER:
    case ValueType.LONG:
    case ValueType.DOUBLE:
      return format.number.short(value, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

    case ValueType.STRING:
    case ValueType.CSV:
    case ValueType.BOOLEAN:
      return String(value);

    case ValueType.TIMESTAMP:
      return format.dateTime.shortWithFullYear(value);

    case ValueType.DURATION:
      return format.duration(value);

    default:
      return String(JSON.stringify(value, null, 2));
  }
};
